import "materialize-css";

const MaterialActiveDirective = function ($compile) {
    return {
        restrict: 'A',
        compile: function (element, attrs) {
            var field = (attrs.materialActive || attrs.for);
            element.removeAttr("material-active");
            element.attr('ng-class', '{active:' + (attrs.materialActive || attrs.for) + '}');
            var fn = $compile(element);
            return function (scope) {
                fn(scope);
            };
        }
    }
};

MaterialActiveDirective.$inject = ["$compile"];

export { MaterialActiveDirective };